import React, { useState } from "react";
import SelectField from "../../library/components/Select";
import CountingSupervisorEciReport from "./ECIOfficer/CountingSupervisorEciReport";
import EpbDownloadingForceWiseEciReport from "./ECIOfficer/EpbDownloadingForceWiseEciReport";
import EpbDownloadingRecordOfficeWiseEciReport from "./ECIOfficer/EpbDownloadingRecordOfficeWiseEciReport";
import EpbDownloadingStatewiseEciReport from "./ECIOfficer/EpbDownloadingStatewiseEciReport";
import EpbDownloadingUnitOfficeWiseEciReport from "./ECIOfficer/EpbDownloadingUnitOfficeWiseEciReport";
import EpbGenerationEciReport from "./ECIOfficer/EpbGenerationEciReport";
import EpbScanningEciReport from "./ECIOfficer/EpbScanningEciReport";

import CountingSupervisorCeoReport from "./CEO/CountingSupervisorCeoReport";
import EpbGenerationDownloadCeoReport from "./CEO/EpbGenerationDownloadCeoReport";
import EpbScanningCeoReport from "./CEO/EpbScanningCeoReport";

import CountingSupervisorDeoReport from "./DEO/CountingSupervisorDeoReport";
import EpbGenerationDownloadDeoReport from "./DEO/EpbGenerationDownloadDeoReport";
import EpbScanningDeoReport from "./DEO/EpbScanningDeoReport";

import CountingSupervisorRoReport from "./RO/CountingSupervisorRoReport";
import EpbScanningRoReport from "./RO/EpbScanningRoReport";
import EpbGenerationDownloadRoReport from "./RO/EpbGenerationDownloadROReport";

const Reports = () => {
  const [data, setData] = useState({
    roleType: "",
    reportType: ""
  });
//   const [reportList, setReportList] = useState([]);

  let reportList = [ { value: "", label: "Select Reports" },]

  const roleList = [
    { value: "", label: "Select Role" },
    { value: "1", label: "ECI Officers" },
    { value: "2", label: "CEO" },
    { value: "3", label: "DEO" },
    { value: "4", label: "RO" },
  ];
  const eciReportList = [
    { value: "", label: "Select Reports" },
    { value: "eci1", label: "CountingSupervisorEciReport" },
    { value: "eci2", label: "EpbDownloadingForceWiseEciReport" },
    { value: "eci3", label: "EpbDownloadingRecordOfficeWiseEciReport" },
    { value: "eci4", label: "EpbDownloadingStatewiseEciReport" },
    { value: "eci5", label: "EpbDownloadingUnitOfficeWiseEciReport" },
    { value: "eci6", label: "EpbGenerationEciReport" },
    { value: "eci7", label: "EpbScanningEciReport" },
  ];

  const ceoReportList = [
    { value: "", label: "Select Reports" },
    { value: "ceo1", label: "CountingSupervisorCeoReport" },
    { value: "ceo2", label: "EpbGenerationDownloadCeoReport" },
    { value: "ceo3", label: "EpbScanningCeoReport" },
  ];

  const deoReportList = [
    { value: "", label: "Select Reports" },
    { value: "deo1", label: "CountingSupervisorDeoReport" },
    { value: "deo2", label: "EpbGenerationDownloadDeoReport" },
    { value: "deo3", label: "EpbScanningDeoReport" },
  ];

  const roReportList = [
    { value: "", label: "Select Reports" },
    { value: "ro1", label: "CountingSupervisorRoReport" },
    { value: "ro2", label: "EpbScanningRoReport" },
    { value: "ro3", label: "EpbGenerationDownloadRoReport" },
  ];

  if(data.roleType==="1"){
    reportList = eciReportList
  } else if(data.roleType==="2") {
    reportList = ceoReportList
  } else if(data.roleType==="3"){
    reportList = deoReportList
  } else if(data.roleType==="4"){
    reportList = roReportList
  }

  const handleChange = (key, value) => {
    setData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-2">
          <label>Select Role</label>
        </div>
        <div className="col-md-10">
          <SelectField
            inputClass="col-md-2"
            value={data.roleType}
            handleChange={(val) => handleChange("roleType", val)}
            options={roleList}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-2">
          <label>Select Reports</label>
        </div>
        <div className="col-md-10">
          <SelectField
            inputClass="col-md-2"
            value={data.reportType}
            handleChange={(val) => handleChange("reportType", val)}
            options={reportList}
          />
        </div>
      </div>
        {data.reportType === 'eci1' && <CountingSupervisorEciReport/>}
        {data.reportType === 'eci2' && <EpbDownloadingForceWiseEciReport/>}
        {data.reportType === 'eci3' && <EpbDownloadingRecordOfficeWiseEciReport/>}
        {data.reportType === 'eci4' && <EpbDownloadingStatewiseEciReport/>}
        {data.reportType === 'eci5' && <EpbDownloadingUnitOfficeWiseEciReport/>}
        {data.reportType === 'eci6' && <EpbGenerationEciReport/>}
        {data.reportType === 'eci7' && <EpbScanningEciReport/>}
        {data.reportType === 'ceo1' && <CountingSupervisorCeoReport/>}
        {data.reportType === 'ceo2' && <EpbGenerationDownloadCeoReport/>}
        {data.reportType === 'ceo3' && <EpbScanningCeoReport/>}
        {data.reportType === 'deo1' && <CountingSupervisorDeoReport/>}
        {data.reportType === 'deo2' && <EpbGenerationDownloadDeoReport/>}
        {data.reportType === 'deo3' && <EpbScanningDeoReport/>}
        {data.reportType === 'ro1' && <CountingSupervisorRoReport/>}
        {data.reportType === 'ro2' && <EpbScanningRoReport/>}
        {data.reportType === 'ro3' && <EpbGenerationDownloadRoReport/>}
    </div>
  );
};

export default Reports;
